import React from "react";
import {Modal, openModal} from "../modal.js";
import {fetchJson} from "../fetch.js";
import {PubSub} from '../weave/helpers.mjs';
import {currency} from '../helpers.mjs';

const TableRow = ({branchCategory, basketBranches, branches}) => {
    const total = basketBranches.reduce((prev, cur) => prev + cur.total, 0);
    const newTotal = branchCategory.spent + total;
    const remaining = branchCategory.budget - newTotal;
    const suggested = branchCategory.target - branchCategory.spent;
    var bought = (newTotal / Number(branchCategory.budget)) * 100;
    if (branchCategory.budget == 0) {
        bought = 0;
    }
    const branch = branches.find(b => b.branchId === branchCategory.branchId);
    if (!branch) {
        return null;
    }

    return (
        <tr>
            <td>{branch.name}</td>
            <td>{branch.tier}</td>
            <td className="centre">{basketBranches.reduce((prev, cur) => prev + Number(cur.items), 0)}</td>
            <td className="number">{currency(total)}</td>
            <td className="number">{currency(branchCategory.budget)}</td>
            <td className="number">{currency(branchCategory.spent)}</td>
            <td className={newTotal>branchCategory.budget?"negative number":"number"}>{currency(newTotal)}</td>
            <td className={remaining<0 ? "negative number" : "number"}>{currency(remaining)}</td>
            <td className={bought>100 ? "negative number" : "number"}>{bought.toFixed(0)}%</td>
            <td className={suggested<0 ? "negative number" : "number"}>{currency(suggested, 0)}</td>
        </tr>
    );
};

class BudgetConsequences extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stockCategory: 0
        };
    }

    componentDidMount() {
        document.querySelectorAll("table[data-table-sort]").forEach(table => window.Tablesort(table));
    }

    changeStockCategory(event) {
        this.setState({
            stockCategory: Number(event.target.value)
        });
    }

    filtered(branchCategory) {
        if (this.state.stockCategory) {
            return this.props.data.basketBranches.filter(b => b.branchId == branchCategory.branchId && b.stockCategoryId == this.state.stockCategory);
        }
        return this.props.data.basketBranches.filter(b => b.branchId == branchCategory.branchId);
    }

    render() {
        if (!this.props.data.loaded) {
            return (
                <p>Loading...</p>
            );
        }

        var totalItems = 0;
        var totalSpend = 0;
        var totalPrev = 0;
        var totalTarget = 0;
        var totalBudget = 0;
        this.props.data.branches.forEach(branch => {
            var basketBranches = this.filtered(branch);
            totalItems += basketBranches.reduce((prev, cur) => prev + Number(cur.items), 0);
            totalSpend += basketBranches.reduce((prev, cur) => prev + cur.total, 0);
            totalPrev += branch.spent;
            totalBudget += branch.budget;
            totalTarget += branch.target;
        });
        const totalNew = totalPrev + totalSpend;
        var totalBought = (totalNew / totalBudget * 100);
        if (totalBudget == 0) {
            totalBought = 0;
        }

        var stockCategoryOptions = [{
            value: 0,
            label: "All stock categories"
        }, ...this.props.data.stockCategories.map(s => ({
            value: s.id,
            label: s.name
        }))];

        return (<>
            <div className="selectFilter">
                <select className="ds-field" aria-label="Stock category" value={this.state.stockCategory} onChange={this.changeStockCategory.bind(this)}>
                    {stockCategoryOptions.map(option =>
                        <option key={option.value} value={option.value}>{option.label}</option>
                    )}
                </select>
            </div>
            <table className="budgetConsequences basketTable" data-table-sort>
                <thead>
                    <tr>
                        <th>Branch</th>
                        <th>Tier</th>
                        <th className="centre">Items</th>
                        <th className="number">Spend</th>
                        <th className="number">Budget</th>
                        <th className="number">Previous total</th>
                        <th className="number">New total</th>
                        <th className="number">Remaining</th>
                        <th className="number">% bought</th>
                        <th className="number">Suggested spend</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.stockCategory > 0 && this.props.data.branchCategories.filter(b => b.stockCategoryId == this.state.stockCategory).map(branchCategory =>
                        <TableRow key={branchCategory.id} branchCategory={branchCategory} basketBranches={this.filtered(branchCategory)} branches={this.props.data.branches} />
                    )}
                    {this.state.stockCategory === 0 && this.props.data.branches.map(branch =>
                        <TableRow key={branch.branchId} branchCategory={branch} basketBranches={this.filtered(branch)} branches={this.props.data.branches} />
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="2">Totals</td>
                        <td className="centre">{totalItems}</td>
                        <td className="number">{currency(totalSpend)}</td>
                        <td className="number">{currency(totalBudget)}</td>
                        <td className="number">{currency(totalPrev)}</td>
                        <td className="number">{currency(totalNew)}</td>
                        <td className="number">{currency(totalBudget - totalNew)}</td>
                        <td className="number">{totalBought.toFixed(0)}%</td>
                        <td className="number">{currency(totalTarget - totalPrev, 0)}</td>
                    </tr>
                </tfoot>
            </table>
        </>);
    }
}

class BudgetModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
    }

    componentDidMount() {
        PubSub.sub("budgetModal", this.init.bind(this));
    }

    init(basketId, basketBranches = null, prId=0) {
        openModal("budgetConsequencesModal", "Weave outcome");
        this.setState({
            loaded: false
        });
        fetchJson("/basket/budgetConsequences/" + basketId + "/" + prId).then(r => {
            const branches = r.branches.map(branch => ({
                ...branch,
                spent: r.branchCategories.filter(b => b.branchId === branch.branchId).reduce((prev, cur) => prev + cur.spent, 0),
                budget: r.branchCategories.filter(b => b.branchId === branch.branchId).reduce((prev, cur) => prev + cur.budget, 0),
                target: r.branchCategories.filter(b => b.branchId === branch.branchId).reduce((prev, cur) => prev + cur.target, 0)
            }));
            this.setState({
                branchCategories: r.branchCategories,
                basketBranches: basketBranches ? basketBranches : r.basketBranches,
                stockCategories: r.stockCategories,
                branches: branches,
                loaded: true
            });
        }).catch(error => {
            PubSub.pub("budgetConsequencesModal_close") ;
        });
    }

    render() {
        const body = <BudgetConsequences basket={basket} data={this.state} />;

        return (
            <Modal id="budgetConsequencesModal" body={body} buttons={[]} />
        );
    }
}
 
export default BudgetModal;